import styled, { css } from 'styled-components';

// MEDIA QUERIES
const sizes = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px',
};

export const device = {
  mobileS: `(max-width: ${sizes.mobileS})`,
  mobileM: `(max-width: ${sizes.mobileM})`,
  mobileL: `(max-width: ${sizes.mobileL})`,
  tablet: `(max-width: ${sizes.tablet})`,
  laptop: `(max-width: ${sizes.laptop})`,
  laptopL: `(max-width: ${sizes.laptopL})`,
  desktop: `(max-width: ${sizes.desktop})`,
};

// SHARED STYLES
const defaultSpacingValue = '20px';

const sharedHeaderSpacing = css`
  padding: ${defaultSpacingValue};

  & * {
    margin: 0;
  }
`;

const sharedFlexbox = css`
  display: flex;
  justify-content: space-between;
`;

const sharedTableSpacing = css`
  padding: 10px ${defaultSpacingValue};
`;

const sharedHeaderParentStyle = css`
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  padding: ${defaultSpacingValue};
`;

const sharedHeaderBodyStyles = css`
  text-align: left;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
`;

const sharedSeparator = css`
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);

  &:last-child {
    border-bottom: 0px;
  }
`;

// COMPONENTS
export const Container = styled.div`
  ${sharedFlexbox};
  color: rgba(0, 0, 0, 0.94);

  @media ${device.laptop} {
    display: block;
  }
`;

export const ColumnParent = styled.div<{ orderSummary?: boolean }>`
  width: ${props => (props.orderSummary ? '30%' : '65%')};

  @media ${device.laptop} {
    width: 100%;
  }
`;

export const ColumnBody = styled.div`
  background: white;
  border-radius: 10px;
  margin-bottom: 20px;

  overflow-x: auto;
`;

export const OrderHeadline = styled.div`
  display: flex;
  align-items: baseline;
`;

export const OrderNumberParent = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.63);

  width: 100%;
  text-align: right;
  margin-bottom: 1rem;
`;

export const OrderNumber = styled.span`
  font-weight: 500;
  color: black;
`;

export const HeadParent = styled.div`
  ${sharedFlexbox}
  ${sharedHeaderParentStyle}
  ${sharedHeaderSpacing}
`;

export const HeadBody = styled.div`
  ${sharedHeaderBodyStyles}
`;

export const StatusText = styled.div``;

export const DescriptionRow = styled.div<{
  block?: boolean;
  showBillingAddress?: boolean;
}>`
  ${sharedFlexbox};
  ${sharedHeaderSpacing};
  display: ${({ block }) => block && 'block'};
  justify-content: ${({ showBillingAddress }) =>
    showBillingAddress ? 'space-between' : 'unset'};
`;

export const DescriptionCell = styled.div`
  width: 33%;
`;

export const HighlightedText = styled.h4`
  color: rgba(0, 0, 0, 0.93);
  font-weight: 500;
  font-size: 1.1rem;
`;

export const RegularText = styled.div`
  display: flex;
  align-items: center;

  color: rgba(0, 0, 0, 0.63);
  margin-top: 15px;
  width: 80%;
  word-wrap: break-word;
`;

export const CardImageParent = styled.div`
  margin-right: 0.5rem;
`;

// TABLES

export const TableComponent = styled.table`
  width: 100%;
  border-collapse: collapse;
`;
export const TableHeadRow = styled.tr`
  ${sharedHeaderParentStyle};

  /* targets the "Item(s) Ordered" first child */
  & > :first-child {
    white-space: nowrap;
    ${sharedHeaderBodyStyles}
    ${sharedHeaderParentStyle}
  }
`;
export const TableHeadCell = styled.th`
  font-size: 17px;
  text-align: left;
  ${sharedHeaderSpacing}
`;

export const TableCellRow = styled.tr`
  ${sharedSeparator}
`;

export const OrderItem = styled.div`
  margin-left: -120px;
  font-size: 17px;
  color: rgba(0, 0, 0, 0.94);
  min-width: 150px;

  ${sharedTableSpacing}
`;

export const ProductImage = styled.img`
  width: 63px;
  height: 63px;
`;

export const TableCell = styled.td`
  color: rgba(0, 0, 0, 0.63);
  ${sharedTableSpacing}
`;

export const InfoParent = styled.div`
  width: 90%;
  margin: auto;

  padding: ${defaultSpacingValue} 0;

  ${sharedSeparator}
`;

export const InfoRow = styled.div`
  ${sharedFlexbox};

  margin-bottom: 10px;

  &:last-child {
    margin-bottom: unset;
  }
`;

export const DiscountRibbon = styled.div`
  background: #cbf5d8;
  border: 1px solid #257f49;
  border-radius: 4px;
  padding: 10px;
  margin: 10px 0;

  & > div {
    /* Heading / Heading 01 */

    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;

    color: rgba(0, 0, 0, 0.94);
  }
`;

export const InfoType = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;

  color: rgba(0, 0, 0, 0.63);
`;
export const InfoValue = styled.div<{
  isDiscountType?: boolean;
}>`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;

  color: ${({ isDiscountType }) =>
    isDiscountType ? '#00964E' : 'rgba(0, 0, 0, 0.94)'};
`;

export const TotalRow = styled(InfoRow)`
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;

  color: rgba(0, 0, 0, 0.94);
`;

export const LinkText = styled.a``;

export const OrderNumberHeadline = styled.h1`
  width: 100%;
  font-size: 1.3rem;
  font-weight: 400;
  ${({ theme }) => theme.breakpoints.down('md')} {
    font-size: 1.5rem;
  }
  > span {
    font-weight: 500;
  }
`;

export const TrackingID = styled.div`
  display: flex;
  align-items: center;

  > a {
    padding: 0 0 0 5px;
  }
`;

export const BoxIcon = styled.span`
  font-size: 2rem;
  padding: 0 10px 0 0;
`;

export const TrackingInfoRow = styled.div`
  box-sizing: border-box;
  display: grid;

  align-items: center;

  width: 70%;
  background: white;

  > div:first-of-type {
    margin-left: 10px;
  }

  grid-template-columns: 0.5fr 3.5fr 1fr;
`;

export const TrackingInfoHeader = styled(TrackingInfoRow)`
  font-size: 0.7rem;
  color: rgba(0, 0, 0, 0.63);
`;

export const TrackingState = styled.div<{ orderStatus: string }>`
  margin: 0 0 0 20px;
  padding: 2px 6px;
  /* Status backgrounds/$background-status-blue */
  background: ${props =>
    props.orderStatus === 'processing' ||
    props.orderStatus === 'pending' ||
    props.orderStatus === 'partial'
      ? '#d4f0ff'
      : props.orderStatus === 'delivered' ||
        props.orderStatus === 'ready' ||
        props.orderStatus === 'shipped'
      ? '#CBF5D8'
      : props.orderStatus === 'delayed' || props.orderStatus === 'backorder'
      ? '#FFE7D1'
      : props.orderStatus === 'cancelled'
      ? '#FFE6E8'
      : ''};
  border-radius: 24px;

  /* Hover states/$background-interactive-hover */
  color: ${props =>
    props.orderStatus === 'processing' ||
    props.orderStatus === 'pending' ||
    props.orderStatus === 'partial'
      ? '#0277b5'
      : props.orderStatus === 'delivered' ||
        props.orderStatus === 'ready' ||
        props.orderStatus === 'shipped'
      ? '#257F49'
      : props.orderStatus === 'delayed' || props.orderStatus === 'backorder'
      ? '#CE6215'
      : props.orderStatus === 'cancelled'
      ? '#CF2E38'
      : ''};
`;

export const ReviewStatusRow = styled.div`
  box-sizing: border-box;
  display: grid;
  gap: 10px;
  align-items: center;
  margin: 20px 0px;
  width: 100%;
  background: white;
  grid-template-columns: 0.5fr 1.5fr 1fr 0.8fr;
  color: rgba(1, 0, 0, 0.63);
`;

export const ThumbnailWrapper = styled.div`
  cursor: pointer;
`;

export const ReviewStatusHeader = styled.div`
  font-weight: bold;
`;

export const TextCenter = styled.div`
  text-align: center;
`;

export const BodyContainer = styled.div`
  padding: 0px 20px;
  width: 60%;
`;

export const SubscriptionDisclaimer = styled.div`
  font-size: 0.9rem;
  font-weight: 500;
  margin-top: 10px;
  color: ${({ theme }) => theme.palette.green};
`;

export const PercentageSaved = styled.div`
  margin-top: 10px;
  font-size: 0.8rem;
  color: #388e3c;
`;
